import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "Do you accept Medicare or Medicaid?",
    answer: "No, ANEMT operates on a private-pay only basis. We do not bill Medicare, Medicaid, or insurance companies. Payment is expected at the time of service.",
  },
  {
    question: "How far in advance should I schedule?",
    answer: "We recommend scheduling at least 24-48 hours in advance for best availability. However, we can often accommodate same-day requests depending on our schedule.",
  },
  {
    question: "What areas do you serve?",
    answer: "We primarily serve the Portland, OR metro area and surrounding communities. Contact us to confirm service to your specific location.",
  },
  {
    question: "Can a family member ride with me?",
    answer: "Yes, we welcome family members or caregivers to accompany patients at no additional charge, space permitting.",
  },
];

const FAQPreview = () => {
  return (
    <section className="py-14 sm:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-3 sm:mb-4">
            Common Questions
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Quick answers to help you get started
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-6 sm:mb-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-border">
                <AccordionTrigger className="text-left text-sm sm:text-base md:text-lg font-medium py-3 sm:py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center">
          <Button asChild variant="outline" size="lg" className="rounded-xl text-sm sm:text-base">
            <Link to="/faq" className="flex items-center">
              View All FAQs
              <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FAQPreview;
